import { SnackBarModule } from "./SnackBarModule";

export function formatErrors(errors) {
    let formattedErrors = "";

    for (const field in errors) {

        if (Object.prototype.hasOwnProperty.call(errors, field)) {
            errors[field].forEach(errorMessage => {
                formattedErrors += `${errorMessage}\n`;
            });
        }
    }
    return formattedErrors.trim();
}

export async function handleErrors(response) {

    if (!response.errors) {
        await SnackBarModule(response.message, 'error');
        return;
    }

    let errorMessage = formatErrors(response.errors);
    await SnackBarModule(errorMessage, 'error');
}